import React from 'react';
import Icon from '@mui/material/Icon';
import { useTheme as useMuiTheme, alpha } from '@mui/material/styles';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

export function StateCard({ icon, title, subtitle, actionLabel, onAction }) {
  const theme = useMuiTheme();

  return (
    <MDBox
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: '22px',
        textAlign: 'center',
        // ✅ card içinde card hissini öldür: border/shadow yok
        boxShadow: 'none',
        border: 'none',
        // ✅ çok hafif ayrım (paper ile aynı olmasın)
        background:
          theme.palette.mode === 'dark'
            ? `linear-gradient(180deg, ${alpha(theme.palette.background.default, 0.55)}, ${alpha(
                theme.palette.background.default,
                0.35
              )})`
            : `linear-gradient(180deg, ${alpha(theme.palette.background.default, 0.75)}, ${alpha(
                theme.palette.background.default,
                0.55
              )})`,
      }}
    >
      <MDBox
        sx={{
          width: 64,
          height: 64,
          borderRadius: '22px',
          display: 'grid',
          placeItems: 'center',
          mx: 'auto',
          // ✅ ikon kutusu da flat
          background: alpha(theme.palette.action.hover, 0.7),
          boxShadow: 'none',
          border: 'none',
        }}
      >
        <Icon sx={{ fontSize: 34, opacity: 0.85 }}>{icon}</Icon>
      </MDBox>

      <MDTypography variant="h6" fontWeight="bold" sx={{ mt: 1.4 }}>
        {title}
      </MDTypography>

      <MDTypography
        variant="button"
        fontWeight="medium"
        sx={{ color: theme.palette.text.secondary }}
      >
        {subtitle}
      </MDTypography>

      {actionLabel ? (
        <MDBox mt={2}>
          <MDButton
            variant="gradient"
            color="info"
            sx={{ borderRadius: '14px' }}
            onClick={onAction}
          >
            {actionLabel}
          </MDButton>
        </MDBox>
      ) : null}
    </MDBox>
  );
}
